export enum LeadByOption {
  TYPE = "type",
  SOURCE = "source",
}
